import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Space,
  Text,
  Divider,
  Popup,
  Conditional,
} from '@cashfree-intl/coherent';

// Utils
import { convertAmountToAbbreviation, formatCurrency } from 'utils/common';
import { DATE_AND_TIME_FORMAT } from 'utils/constants';

// Components
import CustomIcons from 'components/CustomIcons';
import { ICON_NAME } from 'components/CustomIcons/types';

// Styled
import { StyledNextSettlementsAmountCard } from '../styled';

function NextSettlementsAmountCard(props) {
  const { nextSettlementsDetails } = props;
  const {
    settlementType,
    isISDisabled,
    settlementCycle,
    nextNSSettlementTime,
    nextNSSettlementAmount,
    nextISSettlementTime,
    nextISSettlementAmount,
    hasPendingISSettlement,
  } = nextSettlementsDetails;
  const isNextNSSettlement =
    settlementType === 'NORMAL_SETTLEMENT' ||
    (settlementType === 'INSTANT_SETTLEMENT' && isISDisabled);
  const nextSettlementAmount = isNextNSSettlement
    ? nextNSSettlementAmount
    : nextISSettlementAmount;
  const nextSettlementTime = isNextNSSettlement
    ? moment(nextNSSettlementTime).format(DATE_AND_TIME_FORMAT)
    : moment(nextISSettlementTime).format(DATE_AND_TIME_FORMAT);
  const showFooter =
    settlementType === 'INSTANT_SETTLEMENT' &&
    !isISDisabled &&
    hasPendingISSettlement;

  return (
    <StyledNextSettlementsAmountCard className="p-0">
      <Text variant="h16" color="bodyLight" className="px-3 pt-2">
        Upcoming Settlement
      </Text>

      <Divider />

      <Space gap={1} direction="column" className="px-3 pb-2">
        <Text variant="h28">{formatCurrency(nextSettlementAmount || 0)}</Text>
        <Space gap={1} alignItems="center">
          <Text>Expected settlement by</Text>
          <Text strong>{nextSettlementTime}</Text>
          <Popup
            content={
              <div>
                <Text variant="b12" color="bodyLight">
                  Current Settlement Cycle
                </Text>
                <Conditional if={settlementCycle}>
                  <Text strong variant="b12" className="mt-1">
                    Transaction + {settlementCycle} working days
                  </Text>
                </Conditional>
                <Text variant="b12" color="placeholder" className="mt-2">
                  This is the day your settlement is processed, which is two
                  working days after the transaction day.
                </Text>
              </div>
            }
            trigger={
              <span className="flex">
                <CustomIcons componentName={ICON_NAME.INFO} />
              </span>
            }
            position="bottom left"
          />
        </Space>
      </Space>

      <Conditional if={showFooter}>
        <Space gap={1} alignItems="center" className="px-3 py-1 footer">
          <CustomIcons componentName={ICON_NAME.INFO} width="12" height="12" />
          <Text variant="b12">
            Instant Settlement Limit Reached.{' '}
            {convertAmountToAbbreviation(nextNSSettlementAmount, true)} will be
            settled on{' '}
            {moment(nextNSSettlementTime).format(DATE_AND_TIME_FORMAT)}.
          </Text>
        </Space>
      </Conditional>
    </StyledNextSettlementsAmountCard>
  );
}

NextSettlementsAmountCard.propTypes = {
  nextSettlementsDetails: PropTypes.object.isRequired,
};

export default memo(NextSettlementsAmountCard);
